export class RegisterChargeAccountEntity {
    createUser;
    chargeAccountData;

    constructor(createUser, chargeAccountData) {
        this.createUser = createUser;
        this.chargeAccountData = chargeAccountData;
    }
}